import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery, UseQueryOptions } from "@tanstack/react-query";

type UseMaintenanceObjectiveSystemsProps<T> = {
  filters?: {
    search?: string;
    equipmentId?: string;
    page?: number;
  };
  options?: Partial<UseQueryOptions<any>>;
  mapper?: (data: any) => T,
};

export const useMaintenanceObjectiveSystems = <T,>({
  filters: { search, equipmentId, page } = {},
  options = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceObjectiveSystemsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['maintenanceObjectiveSystems', search, equipmentId, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/objective_systems`, {
        params: {
          search: search,
          'q[equipment_id_eq]': equipmentId,
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { data, meta, ...rest };
};
